/**
 * @module views\sys\file
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from '../../../components/ghBase';

@Component
export default class File extends GhBase {
  private argsQuery = { keyword: "" };
  private selecteds = [];



 

  
  
  
}
